import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouteReuseStrategy, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { popperVariation, TippyModule, tooltipVariation } from '@ngneat/helipopper';
// import { QuillModule } from 'ngx-quill';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';
import { SocketIoModule } from '@core/socket-io';
import { AppRouting } from './app.routing';
import { ShellModule } from './shell/shell.module';
import { AppUpdateService } from '@core/services';
import { RouteReusableStrategy } from '@core/helpers';
import { PlatformsModule } from './platforms/platforms.module';
import { AppComponent } from './app.component';
import { AuthModule } from '@auth';
import { ApiPrefixInterceptor, ErrorHandlerInterceptor } from '@core/interceptors';
import { NotificationsComposition } from '@shared/compositions';
import { provideDialogConfig } from '@ngneat/dialog';
import { provideHotToastConfig } from '@ngxpert/hot-toast';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production, scope: '/' }),
    FormsModule,
    RouterModule,
    TranslateModule.forRoot(),
    // QuillModule.forRoot({
    //   modules: {
    //     toolbar: [
    //       ['bold', 'italic', 'underline', 'strike'],
    //       [{ header: 1 }, { header: 2 }],
    //       [{ list: 'ordered' }, { list: 'bullet' }],
    //       [{ size: ['small', false, 'large', 'huge'] }],
    //       [{ header: [1, 2, 3, 4, 5, 6, false] }],
    //     ],
    //   },
    // }),
    TippyModule.forRoot({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
    NgSelectModule,

    SocketIoModule.forRoot({
      rootUrl: environment.serverUrl,
      options: {
        transports: ['websocket'],
      },
    }),
    AuthModule,
    ShellModule,
    PlatformsModule,
    AppRouting,
  ],
  providers: [
    provideDialogConfig({
      enableClose: false,
    }),
    provideHotToastConfig({
      reverseOrder: true,
      dismissible: true,
      autoClose: true,
      position: 'top-right',
      theme: 'snackbar',
    }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
    NotificationsComposition,
    AppUpdateService,
  ],
})
export class AppModule {}
